import styled from "styled-components";


export const CustomModalContentContainer = styled.div`
	display: flex;
	max-height: 72px;
	overflow-y: auto;
	padding-right:	8px;
	flex-wrap: wrap;
	justify-content: center;
	gap:24px;

  &::-webkit-scrollbar {
      width: 6px;
  }

  &::-webkit-scrollbar-track {
      background: ${props => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.colors.lighterGray};
      border-radius: 3px;
  }
`

export const DocumentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 4px;
    align-items: center;
`